import React from 'react'

const CommentInput = ({Value,setValue,Action}) => {
  return (
    <div className='comment_input_container'>
      <div className='comment_input_field'>
        <input type='text' value={Value} placeholder='Add a comment...' onChange={(e)=>setValue(e.target.value)}/>
      </div>
      <div className='comment_button'>
        <button onClick={Action}>Post</button>
      </div>
    </div>
  )
}

export default CommentInput
